module.exports = __webpack_public_path__ + "img/Sites right now.14f8623d.png";